export default __webpack_public_path__ + "static/media/bre_pfp.8b1e6662.png";